import { api } from "./api";

export interface MemoryItem {
  id: string;
  agent_instance_id: string;
  content: string;
  created_at: string;
}

export const memoryService = {
  list: (agentId: string) =>
    api.get<MemoryItem[]>(`/agents/${agentId}/memories`),
  create: (agentId: string, content: string) =>
    api.post<MemoryItem>(`/agents/${agentId}/memories`, { content }),
  update: (agentId: string, memoryId: string, content: string) =>
    api.put<MemoryItem>(`/agents/${agentId}/memories/${memoryId}`, { content }),
  delete: (agentId: string, memoryId: string) =>
    api.delete(`/agents/${agentId}/memories/${memoryId}`),
};
